export default "__VITE_ASSET__3b391f3c__"